var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00072 7.70823L1.75472 12.9542C1.66139 13.0476 1.54672 13.0976 1.41072 13.1042C1.27472 13.1109 1.15339 13.0609 1.04672 12.9542C0.940052 12.8476 0.886719 12.7296 0.886719 12.6002C0.886719 12.4709 0.940052 12.3529 1.04672 12.2462L6.29272 7.00023L1.04672 1.75423C0.953385 1.6609 0.903385 1.54623 0.896719 1.41023C0.890052 1.27423 0.940052 1.1529 1.04672 1.04623C1.15339 0.939564 1.27139 0.88623 1.40072 0.88623C1.53005 0.88623 1.64805 0.939564 1.75472 1.04623L7.00072 6.29223L12.2467 1.04623C12.3401 0.952897 12.4551 0.902897 12.5917 0.89623C12.7271 0.889564 12.8481 0.939564 12.9547 1.04623C13.0614 1.1529 13.1147 1.2709 13.1147 1.40023C13.1147 1.52956 13.0614 1.64756 12.9547 1.75423L7.70872 7.00023L12.9547 12.2462C13.0481 12.3396 13.0981 12.4546 13.1047 12.5912C13.1114 12.7266 13.0614 12.8476 12.9547 12.9542C12.8481 13.0609 12.7301 13.1142 12.6007 13.1142C12.4714 13.1142 12.3534 13.0609 12.2467 12.9542L7.00072 7.70823Z",
    fill: "#AAAAA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClear);
export default __webpack_public_path__ + "static/media/search-clear.5340204d5abe175667b72b2d22378e06.svg";
export { ForwardRef as ReactComponent };